import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/competence/competencetask/";

export default class CompetenceTaskApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getCompetenceTasks(params) {
    return await request.post(`${rootRoute}getCompetenceTasks`, {
      filter: params,
      parameters: {},
    });
  }
  async getCompetenceTask(id) {
    return await request.post(`${rootRoute}getCompetenceTask`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createCompetenceTask(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createCompetenceTask`, { data });
  }
  async deleteCompetenceTask(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteCompetenceTask`, { data });
  }
  async editCompetenceTask(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateCompetenceTask`, { data });
  }
}
